import React from 'react';
import PropTypes from 'prop-types';

import { getEntityUrl } from '@culture/common-helpers/cultureUtils';
import CommonPropTypes from 'utils/propTypes/common';

import EntityCard from './EntityCard';

const InstituteCard = ({ data, size }) => {
	const { title, locale } = data;
	const instituteUrl = getEntityUrl('streamingPlatforms', data);

	return (
		<EntityCard
			title={title}
			image={data.thumbnailFile}
			place={locale && { title: locale.title }}
			size={size}
			url={instituteUrl}
		/>
	);
};

InstituteCard.propTypes = {
	data: CommonPropTypes.entity.isRequired,
	size: PropTypes.string
};

export default InstituteCard;
